module.exports = __webpack_public_path__ + "media/placeholder_movil.d35cfbc3.mp4";